import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AvisService } from 'src/app/services/avis.service';
import { SharedService } from 'src/app/services/sharedService';
import { TaxPayerService } from 'src/app/services/taxPayer.service';
import { UserService } from 'src/app/services/user.service';
import { TasDataSource } from 'src/app/services/tasGovTable.datasource';
import { TaxPayerDialogComponent } from '../../../dialogs/tax-payer-dialog/tax-payer-dialog.component';

@Component({
  selector: 'gov-bind-taxpayer',
  templateUrl: './bind-taxpayer.component.html',
  styleUrls: ['./bind-taxpayer.component.css']
})
export class BindTaxpayerToPropertyComponent implements OnInit, AfterViewInit {
  @Output() onTaxpayerSelected = new EventEmitter<any>();
  displayedColumns: string[] = ['tin', 'name', 'action'];
  dataSource: TasDataSource;
  text: string
  currentUser: any
  selectedTaxpayer: any = null;
  loading = { inProgress: false, downloadInProgress: false }
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  filterObject: {};

  constructor(
    public dialogRef: MatDialogRef<BindTaxpayerToPropertyComponent>,
    public sharedService: SharedService,
    public taxPayerService: TaxPayerService,
    public avisService: AvisService,
    public userService: UserService,
    public confirmationDialog: MatDialog) {}

  async ngOnInit() {
    this.dataSource = new TasDataSource(this.taxPayerService)
  }

  public objectComparisonFunction = function (option, value): boolean {
    if (value)
      return option === value;
    return false;
  }

  advancedSearch(filter) {
    if (!this.filterObject) {
      this.filterObject = {}
    }
    let advF = [
      'tin',
      'name',
      'telephone'
    ];
    advF.forEach((elem) => {
      if (!filter[elem] || filter[elem].length === 0) delete this.filterObject[elem];
    });
    this.filterObject = Object.assign({}, this.filterObject, filter);
    this.dataSource.emptyData()
    this.loading.inProgress = true
    this.dataSource.loadData(
      "tax-payers",
      '',
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.filterObject,
      this.loading
    );
  }

  onSelectTaxpayer(taxpayer, event: MatCheckboxChange) {
    if (event.checked) {
      this.selectedTaxpayer = taxpayer;
      this.onTaxpayerSelected.emit(taxpayer);
    } else {
      this.selectedTaxpayer = null;
      this.onTaxpayerSelected.emit(null);
    }
  }

  reset() {
    this.filterObject = {};
    this.selectedTaxpayer = null;
    this.dataSource.emptyData();
    this.onTaxpayerSelected.emit(null);
  }

  ngAfterViewInit() {
    const interval = setInterval(() => {
      if (this.paginator && this.sort) {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
        merge(this.sort.sortChange, this.paginator.page)
          .pipe(tap(() => this.loadTaxPayerData()))
          .subscribe();
        clearInterval(interval);
      }
    }, 100);
  }
  
  loadTaxPayerData() {
    this.dataSource.emptyData()
    this.loading.inProgress = true
    this.dataSource.loadData('tax-payers',
      '',
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, this.filterObject, this.loading);
  }

  openTaxPayerDialog() {
    const dialogRef = this.confirmationDialog.open(TaxPayerDialogComponent, {
      width: '800px',
      panelClass: 'custom-dialog-container',
      data: null
    });
  
    dialogRef.afterClosed().subscribe(tin => {
      if (!tin) return;
  
      this.selectedTaxpayer = { tin };
  
      this.onTaxpayerSelected.emit(this.selectedTaxpayer);
  
      this.filterObject = { tin };
      this.loadTaxPayerData();
    });
  }

}
